module.exports = __webpack_public_path__ + "img/micon-1.231c54c4.svg";